import { render, staticRenderFns } from "./comment-dialog.vue?vue&type=template&id=4fe7642b&"
import script from "./comment-dialog.vue?vue&type=script&lang=js&"
export * from "./comment-dialog.vue?vue&type=script&lang=js&"
import style0 from "./comment-dialog.vue?vue&type=style&index=0&id=4fe7642b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports